import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
// custom import
import UserManagement from "../../../Services/UserManagement/UserManagementService";
import {
  showLoader,
  hideLoader,
} from "../../../Redux/Slice/Loader/loaderSlice";

import { HandleApiError } from "../../../Utils/CommonErrors/HandleApiError";
import showToast from "../../../Utils/Toast/ToastNotification";
// css
import "./Viewuser.css";

const Viewuser = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // states
  const [userDetails, setUserDetails] = useState(null);
  const token = useSelector((state) => state.auth?.user?.data?.body?.data?.token)

  const getUserDetails = async () => {
    dispatch(showLoader());
    try {
      const user = await UserManagement.getUser(id, token);
      setUserDetails(user?.data?.body?.data.users[0]);
    } catch (error) {
      await HandleApiError(error)
    } finally {
      dispatch(hideLoader());
    }
  };
  useEffect(() => {
    getUserDetails();
  }, []);

  const handleResend = async (user) => {
    try {
      dispatch(showLoader());
      const response = await UserManagement.resendEmail({ email: user.email });

      if (response?.data?.statusCode === 200) {
        showToast("success", "Invitation resent successfully!");
        getUserDetails();
      } else {
        showToast("error", "Failed to resend invitation.");
      }
    } catch (error) {
      HandleApiError(error);
    } finally {
      dispatch(hideLoader());
    }
  };

  if (!userDetails) {
    return null;
  }

  return (
    <>
      <div className="main-inner-block">
        <div className="heading-content">View User</div>
        <div className="content">
          <div className="white-box">
            <form>
              <div class="d-flex gap-3 create-user-block w-100 justify-content-between">
                <div className="row m-0 w-100 detail-item">
                  <div class="mb-3 col-lg-3 ps-0 padding-right">
                    <label for="firstName" class="form-label">
                      Name
                    </label>
                    <div className="form-input-block">
                      {userDetails.first_name} {userDetails.last_name}
                    </div>
                  </div>

                  <div class="mb-3 col-lg-3 padding-left">
                    <label for="lastName" class="form-label">
                      Email
                    </label>
                    <div className="form-input-block">{userDetails.email}</div>
                  </div>
                  <div class="mb-3 col-lg-3 padding-left">
                    <label for="email" class="form-label">
                      Assign Role
                    </label>
                    <div className="form-input-block">
                      {userDetails.role.name}
                    </div>
                  </div>

                  <div class="mb-3 col-lg-3 padding-left">
                    <label for="email" class="form-label">
                      Status
                    </label>
                    {userDetails.is_active ? (
                      <div className="form-input-block">Active</div>
                    ) : (
                      <div className="form-input-block">Inactive</div>
                    )}
                  </div>
                  <div class="mb-3 col-md-3 ps-0 padding-right">
                    <label for="email" class="form-label">
                      Invitation Status
                    </label>
                    {userDetails.invitation_status ? (
                      <div class="form-input-block d-flex align-items-center gap-2">
                        {userDetails.invitation_status.charAt(0).toUpperCase() +
                          userDetails.invitation_status.slice(1)}

                        {userDetails.invitation_status === "expired" && (
                          <button
                            type="button"
                            className="btn btn-link p-0 m-0 resend-btn"
                            title="Resend Invite"
                            onClick={() => handleResend(userDetails)}
                            style={{ cursor: "pointer" }}
                          >
                            <i class="fa fa-repeat" aria-hidden="true"></i>
                          </button>
                        )}
                      </div>
                    ) : (
                      <div class="form-input-block">N/A</div>
                    )}
                  </div>

                  <div class="mb-3 col-lg-3 padding-left">
                    <label for="email" class="form-label">
                      Date Created
                    </label>
                    <div className="form-input-block">
                      {" "}
                      {userDetails.created_at
                        ? new Date(userDetails.created_at).toLocaleDateString()
                        : "-"}
                    </div>
                  </div>

                  <div class="mb-3 col-lg-3 padding-left">
                    <label for="phone" class="form-label">
                      Phone Number
                    </label>
                    <div className="form-input-block">
                      {userDetails.phone_number
                        ? userDetails.country_code + " " + userDetails.phone_number
                        : "-"}
                    </div>
                  </div>

                </div>
              </div>
              <div className="text-center d-flex justify-content-center button-block gap-3 mt-3">
                <button
                  type="submit"
                  class="green-btn submit-btn view-btn"
                  onClick={() => navigate("/user-listing")}
                >
                  Back
                </button>

                <button
                  type="submit"
                  class="green-btn submit-btn view-btn"
                  onClick={() => navigate(`/update-user/${id}`)}
                >
                  Edit Details
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Viewuser;
